'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-tabs__header {\n  margin-bottom: 30px; }\n  .varta-tabs__header--centered {\n    text-align: center; }\n\n.varta-tabs__link {\n  color: #12273a; }\n  .varta-tabs__link + .varta-tabs__link {\n    margin-left: 20px; }\n  .varta-tabs__link--active {\n    font-weight: 700;\n    border-bottom: 3px solid #fada35; }\n";
styleInject_es(css_248z);
